import React from 'react';
import PropTypes from 'prop-types';
import InboxMessageProp from '../../../../../sections/inbox/propTypes/inboxMessageProp';
import {
  displayTrophyName,
  displayUserName,
  INBOX_MSG_TYPE,
  colors,
} from '../../../../../services/utilityFunctions';
import ColoredTranslation from '../../../../ColoredTranslation';
import translate from '../../../../translate';

function NotificationMessage({ t, notification }) {
  const userName = notification.target
    ? displayUserName(notification.target)
    : t('n/a');

  switch (notification.type) {
    case INBOX_MSG_TYPE.RATING:
    case INBOX_MSG_TYPE.LIKE:
    case INBOX_MSG_TYPE.COMMENT:
    case INBOX_MSG_TYPE.NEW_TIP:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: userName,
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.GAME_START:
    case INBOX_MSG_TYPE.GAME_END: {
      const challengeName = notification.game?.name || t('n/a');
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: challengeName,
              color: colors('dynamic'),
            },
          ]}
        />
      );
    }
    case INBOX_MSG_TYPE.TROPHY:
      if (notification.target) {
        return (
          <ColoredTranslation
            className="notification-list-item-description"
            defaultColor="#6f6c80"
            text={t(`notifications.messages.${notification.type}_user`)}
            replacements={[
              {
                text: userName,
                color: colors('dynamic'),
              },
            ]}
          />
        );
      }
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: displayTrophyName(t, notification.trophy),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.CHAT_JOINED: {
      const chatName = notification.chatGroup?.name || t('n/a');
      if (notification.target) {
        return (
          <ColoredTranslation
            className="notification-list-item-description"
            defaultColor="#6f6c80"
            text={t(`notifications.messages.${notification.type}_user`)}
            replacements={[
              {
                text: userName,
                color: colors('dynamic'),
              },
              {
                text: chatName,
                color: colors('dynamic'),
              },
            ]}
          />
        );
      }

      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: chatName,
              color: colors('dynamic'),
            },
          ]}
        />
      );
    }
    case INBOX_MSG_TYPE.COURSE_PENDING:
    case INBOX_MSG_TYPE.COURSES_NOT_TAKEN:
    case INBOX_MSG_TYPE.COURSE_REWARDS:
    case INBOX_MSG_TYPE.FIRST_COURSE: {
      const courseName = notification.course?.name || t('n/a');
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: courseName,
              color: colors('dynamic'),
            },
          ]}
        />
      );
    }
    case INBOX_MSG_TYPE.HAPPY_BIRTHDAY:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: userName,
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.UNLOCK_REWARD:
      return (
        <span className="notification-list-item-description">
          {t(`notifications.messages.${notification.type}`)}
        </span>
      );
    case INBOX_MSG_TYPE.CHARITY_REPORT: {
      const coins = 100;
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: coins.toString(),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    }
    case INBOX_MSG_TYPE.SURVEY_REWARDS: {
      const surveyName = notification.survey?.title || t('n/a');
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: surveyName,
              color: colors('dynamic'),
            },
          ]}
        />
      );
    }
    case INBOX_MSG_TYPE.ACCESS_SESSION: {
      const sessionName = notification.accessSession?.name || t('n/a');
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: sessionName,
              color: colors('dynamic'),
            },
          ]}
        />
      );
    }
    case INBOX_MSG_TYPE.USER_INVITED_CREATED:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: notification.target
                ? displayUserName(notification.target)
                : t('basic.n/a'),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.WALLET_WITHDRAW_APPROVED:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: notification.target
                ? displayUserName(notification.target)
                : t('basic.n/a'),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.OPPORTUNITY_NOTE:
    case INBOX_MSG_TYPE.OPPORTUNITY_STATUS:
    case INBOX_MSG_TYPE.OPPORTUNITY_DOCUMENT:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(`notifications.messages.${notification.type}`)}
          replacements={[
            {
              text: notification.target
                ? displayUserName(notification.target)
                : t('basic.n/a'),
              color: colors('dynamic'),
            },
            {
              text: notification?.opportunity?.name || t('basic.n/a'),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.REFERRAL_ORDER:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(
            'inbox_referral_order',
            notification.target
              ? displayUserName(notification.target)
              : t('basic.n/a'),
          )}
          replacements={[
            {
              text: notification.target
                ? displayUserName(notification.target)
                : t('basic.n/a'),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    case INBOX_MSG_TYPE.REFERRAL_LEVEL_UPDATED:
      return (
        <ColoredTranslation
          className="notification-list-item-description"
          defaultColor="#6f6c80"
          text={t(
            (notification?.level?.new || 0) > (notification?.level?.old || 0)
              ? 'inbox_level_upgrade'
              : 'inbox_level_downgrade',
            notification.target
              ? displayUserName(notification.target)
              : t('basic.n/a'),
            notification?.level?.new,
          )}
          replacements={[
            {
              text: notification.target
                ? displayUserName(notification.target)
                : t('basic.n/a'),
              color: colors('dynamic'),
            },
          ]}
        />
      );
    default:
      return '';
  }
}

NotificationMessage.propTypes = {
  t: PropTypes.func.isRequired,
  notification: PropTypes.shape(InboxMessageProp.propTypes).isRequired,
};

export default translate(NotificationMessage);
